import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import { useEffect } from 'react';
import { useStore } from '../../../hooks';

import { observer } from 'mobx-react';
import { Paper } from '@roc/ui';
import { sanitizeHtml } from '@roc/ui/utils';
import { WarningOutlined } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    backgroundColor: '#FEF0ED',
    color: '#642B20',
  },
  content: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
  },
  icon: {
    color: theme.palette.warning.light,
  }
}));




export const PortalBannerMessages = observer(() => {
  const classes = useStyles();
  const { globalStore, userStore } = useStore();

  const allowLoanPricing = userStore.allowLoanPricing;
  const { routeBaseUrl } = globalStore;
  const messages = globalStore?.portalBannerMessages;

  let messageComponents = [];
  messageComponents = messages && messages.map(message => {
    const content: string = message.content.replace(':portal-base-url', routeBaseUrl);

    return (
      <Grid container className={classes.content} spacing={2}>
        <Grid item>
          <WarningOutlined className={classes.icon} />
        </Grid>
        <Grid item xs={11}>
          <Typography gutterBottom>
            <strong>

              {message.title}
            </strong>
            <br />
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}></div>

          </Typography>
        </Grid>
      </Grid >
    );
  }


  );
  return (
    <>
      {(messages?.length > 0  && allowLoanPricing) ? (
        <>
          <Paper className={classes.paper} title="">
            {messageComponents}
          </Paper>
          <br />
        </>) : <Grid />
      }
    </>
  );
});
